import React from 'react';

export const LogosCarousel = () => {
  const logos = [
    { name: 'Toyota', width: '120px' },
    { name: 'Honda', width: '100px' },
    { name: 'Volkswagen', width: '130px' },
    { name: 'Ford', width: '90px' },
    { name: 'Chevrolet', width: '110px' },
    { name: 'Fiat', width: '80px' },
    { name: 'Hyundai', width: '100px' },
    { name: 'Nissan', width: '90px' },
  ];

  // Duplica os logos para criar o loop infinito
  const duplicatedLogos = [...logos, ...logos];

  return (
    <div className="w-full overflow-hidden">
      <span className="text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wider mb-4 block">
        Marcas que trabalhamos
      </span>
      <div className="w-full overflow-hidden">
        <div className="flex items-center gap-8 animate-logos-scroll">
          {duplicatedLogos.map((logo, index) => (
            <div
              key={index}
              className="flex-shrink-0 flex items-center justify-center bg-white dark:bg-dark-800 rounded-lg px-4 py-3 shadow-sm border border-gray-200 dark:border-dark-700"
              style={{ width: logo.width, height: '60px' }}
            >
              <span className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                {logo.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
